import React, { useEffect, useRef, useState } from 'react';
import UpdateCancel from '../../atoms/buttons/UpdateCancel';
import CreateCancel from '../../atoms/buttons/CreateCancel';
import {IconSelector} from '../../atoms/IconSelectorV2';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Checkbox, FormControlLabel, Grid, Typography } from '@material-ui/core';
import { getViews } from '../../../store/views/selectors';
import { findExistingSectNames } from '../../../services/builder/util';
import { sectionNameValidation } from '../../../config/validations';
import Button from '@material-ui/core/Button';
import FieldExtensionTable from '../FieldExtensionTable';
import { setImageMapData } from '../../../store/global/actions';
import AddIcon from '@material-ui/icons/Add';


const defaultOptions = {
  theme: 'bootstrap4',
  iconlib: 'fontawesome4',
  disable_collapse: true,
  compact: true,
  no_additional_properties: true,
  disable_edit_json: true,
  disable_properties: true,
  disable_add_remove: true,
};

export default function FormEditor({
  options,
  validation,
  schema,
  onSave,
  onClose,
  id,
  schemaValues,
  parentID,
  action,
  rootId,
  key,
  keySchema,
  customValidation,
  isUpdating,
  onChangeJsonEditor,
  randomNumber,
  messageExtensionsRequired=false,
  setMessageExtensionsRequired,
  onChangeOperation,
  eventFields,
  setExtendedFieldsData,
  index,
  editorId,
  isAddRow,
  onAddRow,
  nameReadOnly,
  renderCustomIconSelector=false,
  isAlertRequired,
  showAppViewOption,
  openAppView,
  setOpenAppView
}) {
  let elementId = editorId ? editorId : index ? `ui-editor${index}` : `ui-editor`;
  const dispatch = useDispatch();
  const [editor, setEditor] = useState(null);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [formatter, setFormatter] = useState(false);
  const [synError, setSynError] = useState(false);
  const [isImageMap, setIsImageMap] = useState(false);
  const [name, setName] = useState(schemaValues?.name ? schemaValues.name : "");
  const [renderMessageExtensions, setRenderMessageExtensions] = useState(false);
  const inbuiltIcons = ["warn", "success", "error"];

  const views = useSelector(getViews)?.view_schema;

  const [icon, setIcon] = useState( (schemaValues?.iconsrc && schemaValues?.iconsrc.startsWith('http')) ? schemaValues?.iconsrc : schemaValues?.customicon ? schemaValues?.customicon : schemaValues?.icon && !inbuiltIcons.includes(schemaValues?.icon) ? schemaValues?.icon : null);
  
  let schemas = [];
  let defaultFormatter = schemaValues?.formatter !== undefined ? schemaValues.formatter : '/* Write your custom logic to format/update the response value */';
  useEffect(() => {
    

    const customOptions = { ...defaultOptions, ...options, schema };

    const element = document.getElementById(elementId);

    const jsonEditor = new window.JSONEditor(element, customOptions);

    jsonEditor.on('change', () => {
      const values = jsonEditor.getEditor(`${options.form_name_root}`).getValue();
      
      if (onChangeJsonEditor) {
        onChangeJsonEditor(values);
      }
      
      setName(values.name ? values.name : "");

      if (options.form_name_root == 'ui') {
        setIsImageMap(true);
        const selectedType = Object.keys(values?.type)[0];

        if(setMessageExtensionsRequired) setMessageExtensionsRequired(selectedType == "html_form" ? true : false); 

        if (selectedType === 'image-map') {
          setIsImageMap(true);
        } else {
          setIsImageMap(false);
        }
      } else {
        setIsImageMap(false);
      }

        
    });

    jsonEditor.on('ready', () => {
      if (schemaValues) jsonEditor.setValue(schemaValues);
      window.JSONEditor.defaults.custom_validators.push(validation);
      setBtnDisabled(false);

      if(nameReadOnly === true){
        const nameInputElement = document.getElementById(options?.form_name_root == "ui" ? "ui[name]" : options?.form_name_root == "section" ? "section[name]" : "field[name]"); 
        if(nameInputElement != undefined){
          nameInputElement.setAttribute("readOnly", true);
        }
      }
        

      var elementToDisable = element.querySelector(`#${elementId} > div > .h3`);
      if (elementToDisable) {
        elementToDisable.style.display = 'none';
      }

      

      
    });


    setEditor(jsonEditor);

    return () => {
      destryoEditor(jsonEditor);
    };
    

  }, [key, keySchema]);
  const formatterRef = useRef(null);
  const handleEditorDidMount = (editor, monaco) => {
    formatterRef.current = editor;
  };

  const destryoEditor = (jsonEditor) => {
    try {
      jsonEditor.destroy();
    } catch (e) {
      // console.log(console.log('json editor error', e));
    }
  };

  const onSubmit = () => {
    const data = editor.getValue();


    // For saving the field value selected from the tree

    if (data.hasOwnProperty('transaction')) {
      const fieldInEventSection = document.querySelector('[name="datasource[transaction][field]"]');
      if (fieldInEventSection) data.transaction.field = fieldInEventSection.value;
    }

    if (formatter === true) {
      const formatterCode = formatterRef.current?.getValue();

      data.formatter = formatterCode;
    }

    if (options.form_name_root == 'view') {
      if (icon !== undefined && icon !== null){
        data.icon = icon
      };
    }
    // For widget type counter
    if(icon && icon !== null && renderCustomIconSelector){
      data.customicon = icon;
    }

    const validateErrors = validateWithError(data);

    // console.log({ validateErrors });

    if (!validateErrors) return;
    onSave(data);
  };

  const clearErrors = () => {
    const errorDivs = document.querySelectorAll('.validation-error');
    for (let i = 0; i < errorDivs.length; i++) {
      errorDivs[i].remove();
    }
  };

  const validateWithError = (data) => {
    clearErrors();
    let errors = [];

    //json editor validator
    editor.validate();
    if (options.form_name_root !== 'datasource') {
      const name = editor.getValue().name;
      let existingSectionNames = [];

      if (rootId) {
        schemas = views;
        existingSectionNames = findExistingSectNames({ schemas, id: action === 'create' ? parentID : schemaValues?.id, action, rootId });
      } 

      const stringifyNames = JSON.parse(JSON.stringify(existingSectionNames));
      const validationStatus = sectionNameValidation(name, stringifyNames);

      if (validationStatus !== true) {
        errors.push({
          path: options?.form_name_root === 'ui' ? 'ui.name' : options?.form_name_root === 'field' ? 'field.name' : options?.form_name_root === 'view' ? 'view.name' : 'section.name',
          property: 'format',
          message: validationStatus,
        });
      }
    }

    if (customValidation) {
      let customValidationErrors = customValidation(data);
      errors = [...errors, ...customValidationErrors];
    }

    if (errors.length > 0) {

      errors.forEach((error, index) => {
        let types = ['field.type', 'ui.type', 'datasource.mappingType.event'];

        let divContent = '';
        const divPresent = document.getElementById(`validation-error-${error.path}`);

        if (typeof divPresent != 'undefined' && divPresent != null) {
          divContent = document?.getElementById(`validation-error-${error.path}`)?.textContent ? document.getElementById(`validation-error-${error.path}`)?.textContent : '';
        }

        let path = error.path.split('.');

        // Pass isSwitcher property as true in the error object for appending the 'switcher' at the end of the classname
        let name = 
          path[0] +
          path
            .slice(1)
            .map((p) => `[${p}]`)
            .join('') + (error?.isSwitcher ? 'switcher' : '');

        if ((divPresent === null || divContent !== error.message) && !types.includes(error.path)) {
          if (document.getElementsByName(name)[0] !== undefined) {
            console.log("--if--")
            if (name === 'datasource[mappingType][field]') {
              console.log("1")
              document.getElementById('field-container')?.insertAdjacentHTML('afterend', `<p id="validation-error-${error.path}" class="text text-danger validation-error" style="font-family: Roboto,Helvetica;" >${error.message}</p>`);
            } else if (name === 'datasource[mappingType][event][field]') {
              console.log("2")

              document.getElementById(`event-field-container-${randomNumber}`)?.insertAdjacentHTML('afterend', `<p id="validation-error-${error.path}" class="text text-danger validation-error" style="font-family: Roboto,Helvetica;"  >${error.message}</p>`);
            }else {
              console.log("3")

              document.getElementsByName(name)[0].insertAdjacentHTML('afterend', `<p id="validation-error-${error.path}" class="text text-danger validation-error" style="font-family: Roboto,Helvetica;">${error.message}</p>`);
            }
          }else if(error?.isSwitcher && document.getElementById(name) !== undefined){
            document.getElementById(name)?.insertAdjacentHTML('afterend', `<p id="validation-error-${error.path}" class="text text-danger validation-error" style="font-family: Roboto,Helvetica;">${error.message}</p>`);
          }else if(document.querySelector(`[data-schemapath="${error?.path}"]`) !== undefined){
            const element = document.querySelector(`[data-schemapath="${error?.path}"]`)
            element?.insertAdjacentHTML('afterend', `<p id="validation-error-${error.path}" class="text text-danger validation-error" style="font-family: Roboto,Helvetica; margin-bottom:2px; padding-left:5px; ">${error.message}</p>`);

          }
        }

        

        if ((divPresent === null || divContent !== error.message) && types.includes(error.path)) {
          document.querySelectorAll(`[data-schemapath="${error.path}"]`)[0].querySelectorAll('select')[0].insertAdjacentHTML('afterend', `<p id="validation-error-${error.path}" class="text text-danger validation-error" style="font-family: Roboto,Helvetica;" >${error.message}</p>`);
        }
      });

      return false;
    }

    return true;
  };

  const onOpenImageMapEditor = () => {
    dispatch(setImageMapData({ open: true }));
  };


  return (
    <Grid container spacing={1} xs={12} style={{paddingLeft:'5px'}}>
      <Grid item xs={12} style={{ height: 'max-content'}}>
        <div id={elementId}></div>
      </Grid>

      {(options.form_name_root == 'view' || renderCustomIconSelector) && <IconSelector setSelectedIcon={setIcon} selectedIcon={icon} entityType={'view'}  defaultSearchTag={name}/>}

      {messageExtensionsRequired &&  (
        <Grid item xs={12} style={{marginBottom: '10px', overflow: 'hidden'}}>
          <FieldExtensionTable onLoadData={eventFields || []}  setExtendedFieldsData={setExtendedFieldsData} />
        </Grid>
      )}

      {isAddRow && (
        <Grid item xs={12} style={{ marginTop: '-48px', marginLeft: '10px' }}>
          <Button onClick={onAddRow} color="primary" variant="contained" startIcon={<AddIcon />} id="add-row">
            {isAddRow}
          </Button>
        </Grid>
      )}

      {isImageMap && (
        <Grid item xs={12}>
          <Button onClick={onOpenImageMapEditor} id="imageMapEditorBtn" color="primary" variant="contained">
            Open editor
          </Button>
        </Grid>
      )}

      {action === 'edit' && (
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <UpdateCancel updateDisable={btnDisabled || isUpdating || synError} root={options?.form_name_root} content={isUpdating ? 'Updating..' : 'Update'} onUpdate={onSubmit} onCancel={onClose} />
        </Grid>
      )}

      {action === 'create' && (
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <CreateCancel createDisable={btnDisabled || isUpdating} root={options?.form_name_root} content={isUpdating ? 'Creating..' : 'Create'} onCreate={onSubmit} onCancel={onClose} />
        </Grid>
      )}

      {action === 'deploy' && (
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <CreateCancel createDisable={btnDisabled || isUpdating} root={options?.form_name_root} content={isUpdating ? 'Deploying..' : 'Deploy'} onCreate={onSubmit} onCancel={onClose} />
        </Grid>
      )}

      {action === 'run' && (
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {showAppViewOption && (
            <Box 
              onClick={() => setOpenAppView((prev) => !prev)}
              style={{ display: "flex", alignItems: "flex-start", marginRight: "auto", cursor: "pointer" }}
            >
              <Checkbox
                checked={openAppView}
                id="open-app-view-checkbox"
                onChange={(e) => setOpenAppView(e.target.checked)}
                style={{ padding: 0, marginRight: 1 }}
              />

              <Box>
                <Typography variant="body2">
                  Open App View when simulation starts
                </Typography>
            
                <Typography variant="caption" color="text.secondary">
                  Starts the simulation and automatically opens the App View.
                </Typography>
              </Box>
            </Box>
          )}
          <CreateCancel createDisable={btnDisabled || isUpdating} root={options?.form_name_root} content={isUpdating ? 'Processing..' : 'Run'} onCreate={onSubmit} onCancel={onClose} />
        </Grid>
      )}
    </Grid>
  );
}
